/* eslint-disable import/no-cycle */
import i18n from '../../../../../i18n/i18n';
import {CockpitWidgetConfig} from './cockpitWidgetConfig';
import WidgetSettingFormField from '../../../../shared/widgets/WidgetSettingFormField';
import appConfig from '../../../../../utils/appConfig';
import {ValidationRules} from '../../../../../utils/validationRules';

export class TagInterruptionAnalysisWidgetConfig extends CockpitWidgetConfig {
  static widgetType = {
    identifier: 'tag-interruption-analysis',
    name: i18n.t('cockpitWidget.widgetTypeIdentifier.tagInterruptionAnalysis'),
  };

  get tabs() {
    return [
      this.generalSettingsTab,
      this.workplaceTab,
      {
        key: 'tagInterruptionAnalysis',
        label: i18n.t('widget.WidgetSettingsModal.tagInterruptionAnalysisConfigTabTitle'),
      },
    ];
  }

  workplace = [
    {
      id: 'hierarchyId',
      label: i18n.t('cockpitWidget.settings.workplace.label'),
      helpText: i18n.t('cockpitWidget.settings.workplace.help'),
      type: WidgetSettingFormField.fieldTypes.HierarchyTreeWorkplace,
    },
  ];

  static interruptionReasonSource = 'interruptionReasonSource';

  static interruptionReason = 'interruptionReason';

  static getInterruptionTags() {
    if (!appConfig?.interruptionTags) {
      return [];
    }

    const additionalTags = [
      {
        value: TagInterruptionAnalysisWidgetConfig.interruptionReasonSource,
        label: i18n.t('interruptionReasonSource.model.one'),
      },
      {
        value: TagInterruptionAnalysisWidgetConfig.interruptionReason,
        label: i18n.t('interruptionReason.model.one'),
      },
    ];

    const configuredTags = Object.entries(appConfig.interruptionTags).map(([key, value]) => ({
      value: key,
      label: value,
    }));

    return [...additionalTags, ...configuredTags];
  }

  tagInterruptionAnalysis = [
    {
      id: 'daysBack',
      label: i18n.t('tagInterruptionAnalysisWidgetConfig.settings.tagInterruptionAnalysis.daysBack.label'),
      helpText: i18n.t('tagInterruptionAnalysisWidgetConfig.settings.tagInterruptionAnalysis.daysBack.helpText'),
      type: WidgetSettingFormField.fieldTypes.Number,
      unit: i18n.t('tagInterruptionAnalysisWidgetConfig.settings.tagInterruptionAnalysis.daysBack.unit'),
      defaultValue: 3,
      validations: [ValidationRules.minNumber(1), ValidationRules.maxNumber(7)],
    },
    {
      id: 'tags',
      label: i18n.t('tagInterruptionAnalysisWidgetConfig.settings.tagInterruptionAnalysis.tags.label'),
      type: WidgetSettingFormField.fieldTypes.SelectMultiple,
      defaultValue: [],
      options: TagInterruptionAnalysisWidgetConfig.getInterruptionTags(),
      validations: [ValidationRules.required],
    },
  ];
}
